import React from 'react';
import { Wrapper, Menu, Content } from './styled';
import { UbicationSite, Logo, BreadCrumb } from '@app/src/common/header';
import { FlashMessageError } from '@app/src/common/flashMessageError';

interface Props {
  navBar?: boolean;
  ubicationSite?: boolean;
  positionOf?: Array<number>;
  itemActive?: string;
}

export const HeaderSecondary: React.FC<Props> = ({
  navBar,
  ubicationSite,
  positionOf,
  itemActive
}) => (
  <Wrapper>
    <Content>
      <Logo />
      { ubicationSite && <UbicationSite itemActive={itemActive} />}
      { navBar && <Menu itemInicio /> }
      { positionOf && <BreadCrumb positionOf={positionOf} />}
    </Content>
    <FlashMessageError />
  </Wrapper>
);

HeaderSecondary.displayName = 'HeaderSecondary';
